import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Divider,
    Button,
    FormControl,
    TextField,
    MenuItem,
    Select,
    RadioGroup,
    Radio,
    FormLabel,
    FormControlLabel,
    CircularProgress,
} from "@material-ui/core";
import useStyles from "../../../../styles.js";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { decryptData } from "../../../../crypto";

const StudentDetailView = ({ navigationPaths }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
   const decryptedToken = decryptData(sessionStorage.getItem("token"));

    const formatPreference = (str) => {
        if (!str) return "-";
        return str
            .replace(/_/g, " ")       // replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word
    };

    const [applicationPreview, setApplicationPreview] = useState({});

    console.log("applicationPreview", applicationPreview);

    const fetchApplicationPreview = async () => {
        setLoading(true);
        // console.log("location?.state?.rowCode",location?.state?.data?.rowCode)
        // console.log("location?.state?.rowid",location?.state?.data?.rowId)
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_link/one/candidate_details/preview`,
                 {
                registration: {
                    registration_code: location?.state?.data?.rowCode,
                    added_by: location?.state?.data?.rowId,
                },
            },
                {
                    headers: {
                        Authorization: `Bearer ${decryptedToken}`,
                    },
                }
            );
            if (response?.data && response?.data?.application) {
                setApplicationPreview(response?.data?.application);
            } else {
                console.error("Invalid API response format:", response);
            }
        } catch (error) {
            console.error("Error fetching courses:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchApplicationPreview();
    }, []);

    const menuProps = {
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        },
        disablePortal: true,
    };

    const handleBack = async () => {
        navigate(navigationPaths?.prevPath);
    };

    const handleOpenModal = () => {
        setOpen(true);
    }
    return (
        <>
            <ToastContainer />
            <div style={{ position: "relative" }}>
                {loading && (
                    <Box
                        className={classes.loaderOverlay}
                    >
                        <CircularProgress />
                    </Box>
                )}
               <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll}`}
      >
                    <FormControl className={`${classes.w100}`}>
                        <div
                            className={` ${classes.pagescroll} ${classes.h85vh}  ${classes.px1_5}`}
                        >
                            <div
                                className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py1} ${classes.px1_5}`}
                            >
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <Typography
                                        className={`${classes.w24} ${classes.mt0} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                                        variant="h6"
                                        display="inline"
                                    >
                                        Student Details
                                    </Typography>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile} ${classes.mt1}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24} `}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Name (As Per Matriculation Certificate){" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={applicationPreview?.personal_details?.full_name}
                                            name="full_name"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Name"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Father's Name{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={applicationPreview?.personal_details?.father_name}
                                            name="father_name"
                                            type="email"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Father's Name"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Mother's Name{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={applicationPreview?.personal_details?.mother_name}
                                            name="mother_name"
                                            type="email"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Mother's Name"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Nationality <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={applicationPreview?.personal_details?.nationality}
                                            name="nationality"
                                            type="email"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Nationality"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Primary Email Id{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={applicationPreview?.personal_details?.email}
                                            name="email"
                                            type="email"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Primary Email"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Secondary Email Id{" "}
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={
                                                applicationPreview?.personal_details?.email_alternative
                                            }
                                            name="email_alternative"
                                            type="email"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Secondary Email"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Gender <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <RadioGroup
                                            className={`${classes.radiocolor}`}
                                            row
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={applicationPreview?.personal_details?.gender || ""}
                                            name="gender"
                                        >
                                            <FormControlLabel
                                                value="male"
                                                control={
                                                    <Radio
                                                        // onClick={() => setQuestionMarkSystem("same")}
                                                        disabled
                                                    />
                                                }
                                                label="Male"
                                            />
                                            <FormControlLabel
                                                value="female"
                                                control={
                                                    <Radio
                                                        // onClick={() => setQuestionMarkSystem("different")}
                                                        disabled
                                                    />
                                                }
                                                label="Female"
                                            />
                                        </RadioGroup>
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Marital Status{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <RadioGroup
                                            className={`${classes.radiocolor}`}
                                            row
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            disabled
                                            value={
                                                applicationPreview?.personal_details?.marital_status || ""
                                            }
                                            name="marital_status"
                                        >
                                            <FormControlLabel
                                                value="married"
                                                control={
                                                    <Radio
                                                        // onClick={() => setQuestionMarkSystem("same")}
                                                        disabled
                                                    />
                                                }
                                                label="Married"
                                            />
                                            <FormControlLabel
                                                value="unmarried"
                                                control={
                                                    <Radio
                                                        // onClick={() => setQuestionMarkSystem("different")}
                                                        disabled
                                                    />
                                                }
                                                label="Unmarried"
                                            />
                                        </RadioGroup>
                                    </div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Mobile No.
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={applicationPreview?.personal_details?.phone}
                                            name="phone"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Mobile No."
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Altername Mobile No.
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.personal_details?.alternative_phone
                                            }
                                            name="alternative_phone"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Altername Mobile No."
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                           ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            ID Card Type <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                          <TextField
                                            value={
                                                applicationPreview?.personal_details?.id_card_type
                                            }
                                            name="id_card_type"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Id card type"
                                            disabled
                                        />
                                      
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            {applicationPreview?.personal_details?.id_card_type} <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                          
                                            value={applicationPreview?.personal_details?.id_card_number}
                                            name="id_card_number"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter ID card number"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Name as on ID Card{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                          
                                            value={
                                                applicationPreview?.personal_details?.name_as_on_id_card
                                            }
                                            name="name_as_on_id_card"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter Name as on ID"
                                            disabled
                                        />
                                    </div>

                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Visible Identification Mark 1{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                          
                                            value={
                                                applicationPreview?.personal_details
                                                    ?.visible_identification_mark_1
                                            }
                                            name="visible_identification_mark_1"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>

                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Visible Identification Mark 2
                                        </FormLabel>
                                        <TextField
                                         
                                            value={
                                                applicationPreview?.personal_details
                                                    ?.visible_identification_mark_2
                                            }
                                            name="visible_identification_mark_2"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
                                        >
                                            Candidate Category{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                          <TextField
                                         
                                            value={
                                                applicationPreview?.personal_details
                                                    ?.category_type
                                            }
                                            name="category_type"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter category type"
                                            disabled
                                        />
                                       
                                    </div>
                                </div>

                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w40} ${classes.mobilew45}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} 
               ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            D.O.B (As Per Matriculation Certificate DD/MM/YYYY)
                                        </FormLabel>
                                        <TextField
                                            value={
                                                applicationPreview?.personal_details?.dob
                                                    ? new Date(applicationPreview.personal_details.dob)
                                                        .toISOString()
                                                        .split("T")[0]
                                                    : ""
                                            }
                                            name="dob"
                                            type="date"
                                            variant="outlined"
                                            required
                                            disabled
                                            InputProps={{
                                                inputProps: {
                                                    max: new Date().toISOString().split("T")[0],
                                                },
                                            }}
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w15}`}
                                    ></div>
                                </div>
                            </div>

 {applicationPreview?.qualifications_details && (
                            <div
                                className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.mt0_5} ${classes.py1} ${classes.px1_5} ${classes.m0MobileView}`}
                            >
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <Typography
                                        className={`${classes.w24} ${classes.m0MobileView} ${classes.mt0} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                                        variant="h6"
                                        display="inline"
                                    >
                                        Qualification Details
                                    </Typography>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.rowgap16px} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Qualification Type{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <Select
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //     state_id: "",
                                            //     board_university_id: "",
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.qualifications_details
                                                    ?.qualification_type || ""
                                            }
                                            name="qualification_type"
                                            labelId="category-label"
                                            id="state_id"
                                            displayEmpty
                                            className={classes.selectEmpty}
                                            MenuProps={menuProps}
                                            variant="outlined"
                                            disabled
                                        >
                                            <MenuItem disabled value="">
                                                Select Type...
                                            </MenuItem>

                                            <MenuItem key="10th" value="10th">
                                                10th
                                            </MenuItem>

                                            <MenuItem key="12th" value="12th">
                                                12th
                                            </MenuItem>

                                            <MenuItem key="graduation" value="Graduation">
                                                Graduation
                                            </MenuItem>
                                        </Select>
                                    </div>

                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Board Type<span className={classes.textcolorred}>*</span>
                                        </FormLabel>

                                        <TextField

                                            value={
                                                applicationPreview?.qualifications_details?.board_type?.toUpperCase() || ''}
                                            name="visible_identification_mark_1"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                            InputProps={{
                                                style: { textTransform: 'uppercase' },
                                            }}
                                        />
                                    </div>
                                    {applicationPreview?.qualifications_details?.board_type === "mpBoard" && (
                                        <>
                                            <div
                                                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                            >
                                                <FormLabel
                                                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                >
                                                    State <span className={classes.textcolorred}>*</span>
                                                </FormLabel>

                                                <TextField
                                                    // onChange={(e) =>
                                                    //   setApplicationPreview({
                                                    //     ...applicationPreview.personal_details,
                                                    //     [e.target.name]: e.target.value,
                                                    //   })
                                                    // }
                                                    value={
                                                        applicationPreview?.qualifications_details?.state_name
                                                            ?.name
                                                    }
                                                    name="visible_identification_mark_1"
                                                    type="text"
                                                    variant="outlined"
                                                    required
                                                    placeholder="Enter here"
                                                    disabled
                                                />
                                            </div>
                                            <div
                                                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                            >
                                                <FormLabel
                                                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                >
                                                    Board/University
                                                    <span className={classes.textcolorred}>*</span>
                                                </FormLabel>

                                                <TextField
                                                    // onChange={(e) =>
                                                    //   setApplicationPreview({
                                                    //     ...applicationPreview.personal_details,
                                                    //     [e.target.name]: e.target.value,
                                                    //   })
                                                    // }
                                                    value={
                                                        applicationPreview?.qualifications_details
                                                            ?.board_university?.board_university_name
                                                    }
                                                    name="visible_identification_mark_1"
                                                    type="text"
                                                    variant="outlined"
                                                    required
                                                    placeholder="Enter here"
                                                    disabled
                                                />
                                            </div>
                                        </>)}
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Year of Passing{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>

                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.qualifications_details?.passing_year
                                            }
                                            name="visible_identification_mark_1"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>
                                     {applicationPreview?.qualifications_details?.board_type !== "mpBoard" && 
                                        <>
                                            <div
                                                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                            >
                                               
                                            </div>
                                            </>
}
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.m0MobileView} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Total Obtained Marks{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={applicationPreview?.qualifications_details?.marks}
                                            name="marks"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Roll No <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={applicationPreview?.qualifications_details?.roll_no}
                                            name="roll_no"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Grading System{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.qualifications_details?.garding_system
                                            }
                                            name="roll_no"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            {applicationPreview?.qualifications_details?.garding_system}{" "}
                                            <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.qualifications_details?.marks_value
                                            }
                                            name="marks_value"
                                            type="text"
                                            variant="outlined"
                                            required
                                            // placeholder={`Enter ${formDetail.garding_system} here...`}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
 )}

 {applicationPreview?.communication_details && (
                            <div
                                className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.mt0_5} ${classes.py1} ${classes.px1_5}`}
                            >
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <Typography
                                        className={`${classes.w24} ${classes.mt0} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                                        variant="h6"
                                        display="inline"
                                    >
                                        Permanent Address
                                    </Typography>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            House/Street <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.permanent_house_street
                                            }
                                            name="permanent_house_street"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Landmark <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.permanent_lendmark
                                            }
                                            disabled
                                            name="permanent_lendmark"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            State <span className={classes.textcolorred}>*</span>
                                        </FormLabel>

                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.permanent_state_name?.name
                                            }
                                            disabled
                                            name="visible_identification_mark_1"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            City <span className={classes.textcolorred}>*</span>
                                        </FormLabel>

                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.permanent_city_name?.name
                                            }
                                            disabled
                                            name="visible_identification_mark_1"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Pin Code <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.permanent_pin_code
                                            }
                                            disabled
                                            name="marks"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                            </div>
 )}
 {applicationPreview?.communication_details && (
                            <div
                                className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.mt0_5} ${classes.py1} ${classes.px1_5}`}
                            >
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <Typography
                                        className={`${classes.w24} ${classes.mt0} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                                        variant="h6"
                                        display="inline"
                                    >
                                        Present Address
                                    </Typography>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            House/Street <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.current_house_street
                                            }
                                            name="permanent_house_street"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Landmark <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.current_lendmark
                                            }
                                            disabled
                                            name="permanent_lendmark"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            State <span className={classes.textcolorred}>*</span>
                                        </FormLabel>

                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.current_state_name?.name
                                            }
                                            disabled
                                            name="visible_identification_mark_1"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            City <span className={classes.textcolorred}>*</span>
                                        </FormLabel>

                                        <TextField
                                            // onChange={(e) =>
                                            //   setApplicationPreview({
                                            //     ...applicationPreview.personal_details,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.current_city_name?.name
                                            }
                                            disabled
                                            name="visible_identification_mark_1"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} `}
                                    >
                                        <FormLabel
                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                        >
                                            Pin Code <span className={classes.textcolorred}>*</span>
                                        </FormLabel>
                                        <TextField
                                            // onChange={(e) =>
                                            //   setFormDetail({
                                            //     ...formDetail,
                                            //     [e.target.name]: e.target.value,
                                            //   })
                                            // }
                                            value={
                                                applicationPreview?.communication_details
                                                    ?.current_pin_code
                                            }
                                            disabled
                                            name="marks"
                                            type="text"
                                            variant="outlined"
                                            required
                                            placeholder="Enter here"
                                        />
                                    </div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                            </div>
 )}

 {applicationPreview?.response?.length !== 0 && (
                            <div
                                className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.mt0_5} ${classes.py1} ${classes.px1_5} ${classes.m0MobileView}`}
                            >
                                <div
                                    className={` ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <Typography
                                        className={`${classes.w24} ${classes.mt0} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                                        variant="h6"
                                        display="inline"
                                    >
                                        Additional Details
                                    </Typography>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>

                                    {applicationPreview?.response?.map(
                                        (data, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className={`${classes.dflex}  ${classes.mr0_5}  ${classes.flexdirectioncolumn} `}
                                                >
                                                    <Typography className={`${classes.dflex} ${classes.alignItemsCenter}`}>
                                                        {`Q.${index + 1}. `}
                                                        <span dangerouslySetInnerHTML={{ __html: data?.label || "" }} />
                                                    </Typography>

                                                    <Typography className={`${classes.dflex} ${classes.alignItemsCenter}`}>
                                                        Ans.
                                                        <span dangerouslySetInnerHTML={{ __html: data?.response || "" }} />

                                                    </Typography>



                                                </div>
                                            );
                                        }
                                    )}
                                </div>

                            </div>
 )}

 {applicationPreview?.selected_locations?.length !== 0 && (
                            <div
                                className={`${classes.bgwhite} ${classes.m0MobileView} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.mt0_5} ${classes.py1} ${classes.px1_5}`}
                            >
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <Typography
                                        className={`${classes.w24} ${classes.m0MobileView} ${classes.mt0}  ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                                        variant="h6"
                                        display="inline"
                                    >
                                        City Selection
                                    </Typography>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <div
                                        className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.flexwrapwrap} ${classes.dirColumnMobile}`}
                                    >
                                        {applicationPreview?.selected_locations?.map(
                                            (data, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={`${classes.dflex}  ${classes.mr0_5}  ${classes.flexdirectioncolumn} `}
                                                    >
                                                        <FormLabel
                                                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit
                                                                } ${classes.fontsize1} 
            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight
                                                                }  ${index > 3 && classes.mt1}`}
                                                        >
                                                            {formatPreference(data.preference)}{" "}
                                                            <span className={classes.textcolorred}>*</span>
                                                        </FormLabel>
                                                        <TextField
                                                            value={
                                                                data?.city_name
                                                            }
                                                            name="permanent_house_street"
                                                            type="text"
                                                            variant="outlined"
                                                            required
                                                            placeholder="Enter here"
                                                            disabled
                                                        />
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                            </div>
 )}
 {applicationPreview?.documents && (
                            <div
                                className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.mt0_5} ${classes.py1} ${classes.px1_5}`}
                            >
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile}`}
                                >
                                    <Typography
                                        className={`${classes.w24} ${classes.mt0} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                                        variant="h6"
                                        display="inline"
                                    >
                                        Uploaded Documents
                                    </Typography>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                    <div
                                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                    ></div>
                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile} ${classes.mt1}`}
                                >

                                    <>
                                        {applicationPreview?.documents?.uploade_id_proof_image && (
                                            <>
                                                <div
                                                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                                >
                                                    <FormLabel
                                                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                        ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                    >
                                                        Upload ID Proof{" "}
                                                        <span className={classes.textcolorred}>*</span>
                                                    </FormLabel>
                                                    <TextField
                                                        // onChange={(e) =>
                                                        //   setApplicationPreview({
                                                        //     ...applicationPreview.personal_details,
                                                        //     [e.target.name]: e.target.value,
                                                        //   })
                                                        // }
                                                        disabled
                                                        value={
                                                            applicationPreview?.documents?.uploade_id_proof_type
                                                        }
                                                        name="full_name"
                                                        type="text"
                                                        variant="outlined"
                                                        required
                                                        placeholder="Enter here"
                                                    />
                                                </div>

                                                <div
                                                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w30}`}
                                                >
                                                    {applicationPreview?.documents?.uploade_id_proof_image &&
                                                        applicationPreview?.documents
                                                            ?.uploade_id_proof_image && (
                                                            <div className={classes.pdfbuttonWraper} onClick={() => {
                                                                window.open(
                                                                    applicationPreview?.documents
                                                                        ?.uploade_id_proof_image,
                                                                    "_blank",
                                                                    "noopener,noreferrer"
                                                                );
                                                            }}>

                                                                <button
                                                                    className={classes.pdfButton}
                                                                    onClick={() => {
                                                                        window.open(
                                                                            applicationPreview?.documents
                                                                                ?.uploade_id_proof_image,
                                                                            "_blank",
                                                                            "noopener,noreferrer"
                                                                        );
                                                                    }}
                                                                >
                                                                    <PictureAsPdfIcon fontSize="large" />
                                                                </button>
                                                                <Typography className={classes.fonttypographySize}>
                                                                    {applicationPreview?.documents?.uploade_id_proof_image
                                                                        ?.split("/")
                                                                        .pop() || "N/A"}
                                                                </Typography>

                                                            </div>

                                                        )}
                                                    <div className={`${classes.w32}`}></div>
                                                </div>
                                                <div className={`${classes.w32}`}></div>
                                            </>
                                        )}
                                    </>

                                </div>
                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile} ${classes.mt1} `}
                                >

                                    {applicationPreview?.documents?.uploade_dob_proof_type && (
                                        <>
                                            <div
                                                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                            >
                                                <FormLabel
                                                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                        ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                >
                                                    Upload DOB Proof{" "}
                                                    <span className={classes.textcolorred}>*</span>
                                                </FormLabel>
                                                <TextField
                                                    // onChange={(e) =>
                                                    //   setApplicationPreview({
                                                    //     ...applicationPreview.personal_details,
                                                    //     [e.target.name]: e.target.value,
                                                    //   })
                                                    // }
                                                    disabled
                                                    value={
                                                        applicationPreview?.documents?.uploade_dob_proof_type
                                                    }
                                                    name="full_name"
                                                    type="text"
                                                    variant="outlined"
                                                    required
                                                    placeholder="Enter here"
                                                />
                                            </div>

                                            <div
                                                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w30}`}
                                            >
                                                {applicationPreview?.documents?.uploade_dob_proof_image &&
                                                    applicationPreview?.documents
                                                        ?.uploade_dob_proof_image && (
                                                        <div className={classes.pdfbuttonWraper} onClick={() => {
                                                            window.open(
                                                                applicationPreview?.documents
                                                                    ?.uploade_dob_proof_image,
                                                                "_blank",
                                                                "noopener,noreferrer"
                                                            );
                                                        }}>

                                                            <button
                                                                className={classes.pdfButton}
                                                                onClick={() => {
                                                                    window.open(
                                                                        applicationPreview?.documents
                                                                            ?.uploade_dob_proof_image,
                                                                        "_blank",
                                                                        "noopener,noreferrer"
                                                                    );
                                                                }}
                                                            >
                                                                <PictureAsPdfIcon fontSize="large" />
                                                            </button>
                                                            <Typography className={classes.fonttypographySize}>
                                                                {applicationPreview?.documents?.uploade_dob_proof_image
                                                                    ?.split("/")
                                                                    .pop() || "N/A"}
                                                            </Typography>
                                                        </div>
                                                    )}
                                                <div className={`${classes.w32}`}></div>
                                            </div>
                                            <div className={`${classes.w32}`}></div>
                                        </>
                                    )}


                                </div>

                                <div
                                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.dirColumnMobile} ${classes.mt1}`}
                                >

                                    {applicationPreview?.documents?.uploade_certificate_type && (
                                        <>
                                            <div
                                                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                                            >
                                                <FormLabel
                                                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                        ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                >
                                                    Upload 10th/10+2 Certificate{" "}
                                                    <span className={classes.textcolorred}>*</span>
                                                </FormLabel>
                                                <TextField
                                                    // onChange={(e) =>
                                                    //   setApplicationPreview({
                                                    //     ...applicationPreview.personal_details,
                                                    //     [e.target.name]: e.target.value,
                                                    //   })
                                                    // }
                                                    disabled
                                                    value={
                                                        applicationPreview?.documents
                                                            ?.uploade_certificate_type
                                                    }
                                                    name="full_name"
                                                    type="text"
                                                    variant="outlined"
                                                    required
                                                    placeholder="Enter here"
                                                />
                                            </div>

                                            <div
                                                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w30}`}
                                            >
                                                {applicationPreview?.documents
                                                    ?.uploade_certificate_image &&
                                                    applicationPreview?.documents
                                                        ?.uploade_certificate_image && (
                                                        <div className={classes.pdfbuttonWraper} onClick={() => {
                                                            window.open(
                                                                applicationPreview?.documents
                                                                    ?.uploade_certificate_image,
                                                                "_blank",
                                                                "noopener,noreferrer"
                                                            );
                                                        }}>

                                                            <button
                                                                className={classes.pdfButton}
                                                                onClick={() => {
                                                                    window.open(
                                                                        applicationPreview?.documents
                                                                            ?.uploade_certificate_image,
                                                                        "_blank",
                                                                        "noopener,noreferrer"
                                                                    );
                                                                }}
                                                            >
                                                                <PictureAsPdfIcon fontSize="large" />
                                                            </button>
                                                            <Typography className={classes.fonttypographySize}>
                                                                {applicationPreview?.documents?.uploade_certificate_image
                                                                    ?.split("/")
                                                                    .pop() || "N/A"}
                                                            </Typography>
                                                        </div>
                                                    )}
                                                <div className={`${classes.w32}`}></div>
                                            </div>
                                            <div className={`${classes.w32}`}></div>
                                        </>
                                    )}

                                </div>

                                <div
                                    className={`${classes.dflex} ${classes.dirColumnMobile} ${classes.rowgap16px}`}
                                >
                                    <div
                                        className={`${classes.dflex} `}
                                    >

                                        {applicationPreview?.documents?.photo_file && (
                                            <>
                                                <div className={`${classes.mt1}`}>
                                                    <FormLabel
                                                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                                     ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                    >
                                                        Upload Photo{" "}
                                                        <span className={classes.textcolorred}>*</span>
                                                    </FormLabel>

                                                    {applicationPreview?.documents?.photo_file &&
                                                        applicationPreview?.documents?.photo_file && (
                                                            <div
                                                                className={`${classes.dflex} ${classes.justifycenter} `}
                                                            >
                                                                <div
                                                                    style={{
                                                                        background: " #EDFAFF",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "160px",
                                                                        height: "160px",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #DADADA",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            applicationPreview?.documents?.photo_file
                                                                        }
                                                                        alt="Image_preview"
                                                                        style={{ width: "150px", height: "150px" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div
                                        className={`${classes.dflex}  `}
                                    >

                                        {applicationPreview?.documents?.live_photo && (
                                            <>
                                                <div className={` ${classes.mt1}`}>
                                                    <FormLabel
                                                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                                     ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                    >
                                                        Live Camera Capture{" "}
                                                        <span className={classes.textcolorred}>*</span>
                                                    </FormLabel>

                                                    {applicationPreview?.documents?.live_photo &&
                                                        applicationPreview?.documents?.live_photo && (
                                                            <div
                                                                className={`${classes.dflex} ${classes.justifycenter} `}
                                                            >
                                                                <div
                                                                    style={{
                                                                        background: " #EDFAFF",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "160px",
                                                                        height: "160px",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #DADADA",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            applicationPreview?.documents?.live_photo
                                                                        }
                                                                        alt="Image_preview"
                                                                        style={{ width: "150px", height: "150px" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div
                                        className={`${classes.dflex} `}
                                    >

                                        {applicationPreview?.documents?.upload_right_thumb && (
                                            <>
                                                <div className={`${classes.mt1}`}>
                                                    <FormLabel
                                                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                                     ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                    >
                                                        Upload Right Thumb{" "}
                                                        <span className={classes.textcolorred}>*</span>
                                                    </FormLabel>

                                                    {applicationPreview?.documents?.upload_right_thumb &&
                                                        applicationPreview?.documents?.upload_right_thumb && (
                                                            <div
                                                                className={`${classes.dflex} ${classes.justifycenter} `}
                                                            >
                                                                <div
                                                                    style={{
                                                                        background: " #EDFAFF",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "160px",
                                                                        height: "160px",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #DADADA",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            applicationPreview?.documents
                                                                                ?.upload_right_thumb
                                                                        }
                                                                        alt="Image_preview"
                                                                        style={{ width: "150px", height: "150px" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div
                                        className={`${classes.dflex} `}
                                    >

                                        {applicationPreview?.documents?.upload_left_thumb && (
                                            <>
                                                <div className={`${classes.mt1}`}>
                                                    <FormLabel
                                                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                                     ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                    >
                                                        Upload Left Thumb{" "}
                                                        <span className={classes.textcolorred}>*</span>
                                                    </FormLabel>

                                                    {applicationPreview?.documents?.upload_left_thumb &&
                                                        applicationPreview?.documents?.upload_left_thumb && (
                                                            <div
                                                                className={`${classes.dflex} ${classes.justifycenter} `}
                                                            >
                                                                <div
                                                                    style={{
                                                                        background: " #EDFAFF",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "160px",
                                                                        height: "160px",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #DADADA",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            applicationPreview?.documents
                                                                                ?.upload_left_thumb
                                                                        }
                                                                        alt="Image_preview"
                                                                        style={{ width: "150px", height: "150px" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div
                                        className={`${classes.dflex} `}
                                    >

                                        {applicationPreview?.documents?.signature_file && (
                                            <>
                                                <div className={`${classes.mt1}`}>
                                                    <FormLabel
                                                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                                     ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                                                    >
                                                        Signature File{" "}
                                                        <span className={classes.textcolorred}>*</span>
                                                    </FormLabel>

                                                    {applicationPreview?.documents?.signature_file &&
                                                        applicationPreview?.documents?.signature_file && (
                                                            <div
                                                                className={`${classes.dflex} ${classes.justifycenter} `}
                                                            >
                                                                <div
                                                                    style={{
                                                                        background: " #EDFAFF",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "160px",
                                                                        height: "160px",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #DADADA",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            applicationPreview?.documents
                                                                                ?.signature_file
                                                                        }
                                                                        alt="Image_preview"
                                                                        style={{ width: "150px", height: "150px" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </>
                                        )}

                                    </div>
                                </div>
                            </div>
 )}
                        </div>
                    </FormControl>
                </div>
                {/* <div
                    className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
                >
                    <Button onClick={handleBack} className={`${classes.custombtnoutline}`}>
                        Back
                    </Button>
                    <Button
                        onClick={handleOpenModal}
                        className={`${classes.custombtnblue}`}
                    >
                        Submit
                    </Button>
                </div> */}
            </div>
        </>
    );
};

export default StudentDetailView;
